import Chip from "../assets/img/chip.webp";
import MasterCard from "../assets/img/mastercard.webp";
import Visa from "../assets/img/visa.png";
import { useTranslation, Trans } from "react-i18next";

const PaymentMethods=()=>{
    const { t } = useTranslation();
    return <div className="payment-methods section-padding">
        <div className="container">
            <div className="title mb-4 text-center">
                <h2 className="fs-1 text-color-bright">
                    {t('Secure and Fast Payment Methods')}
                </h2>
                <p className="text-muted-color">{t('you can pay online')}</p>
            </div>
            <div className="mastercard-visa">
                <div className="name-detail d-flex justify-content-between mb-2">
                    <div>
                        <h4 className="mb-0 fw-bold text-uppercase">{t('Mastercard')}</h4>
                        <h4 className="mb-0 fw-bold text-uppercase">{t('Visa')}</h4>
                    </div>
                    <div className="bank">
                        <h4>{t('Bank')}</h4>
                        <span>{t('International')}</span>
                    </div>
                </div>
                <div className="chip">
                    <img src={Chip} alt="Chip" height="32" width="32"/>
                </div>
                <div
                    className="card-number d-flex justify-content-between align-items-center gap-4"
                >
                    <h4>1234</h4>
                    <h4>1234</h4>
                    <h4>1234</h4>
                    <h4>1234</h4>
                </div>
                <div className="other-detail">
                    <div className="valid">
                        <span>{t('VALID')}</span>
                        <span>{t('THRU')}</span>
                    </div>
                    <h4>01/28</h4>
                </div>
                <h4 className="mb-0 fw-bold text-uppercase">{t('Cardholder Name')}</h4>
                <div className="img-payment">
                    <img
                        src={MasterCard}
                        alt="Mastercard"
                        height="34"
                        width="34"
                    />
                    <img src={Visa} alt="Mastercard" height="44" width="44"/>
                </div>
            </div>
        </div>
    </div>
}
export default PaymentMethods;